// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerText_root__3_H7K"};